const cocSecondTable = [
  {
    indexId: "1)",
    relNameAgency: "",
    relSignature: "",
    relDate: "",
    relTime: "",
    recNameAgency: "",
    recSignature: "",
    recDate: "",
    recTime: "",
  },
  {
    indexId: "2)",
    relNameAgency: "",
    relSignature: "",
    relDate: "",
    relTime: "",
    recNameAgency: "",
    recSignature: "",
    recDate: "",
    recTime: "",
  },
  {
    indexId: "3)",
    relNameAgency: "",
    relSignature: "",
    relDate: "",
    relTime: "",
    recNameAgency: "",
    recSignature: "",
    recDate: "",
    recTime: "",
  },
  {
    indexId: "4)",
    relNameAgency: "",
    relSignature: "",
    relDate: "",
    relTime: "",
    recNameAgency: "",
    recSignature: "",
    recDate: "",
    recTime: "",
  },
];

export default cocSecondTable;
